const { colors: stingColors } = require('@chargebee/sting-tokens');

// Reserved reporting accents preserve established outcome associations.
// These bright colors are for graphical marks, not text or UI state styling.
// Cohort identity (e.g. Retention vs Control) has its own chart legend mapping.
const reportingColors = {
  retained: '#25cda8',
  canceled: '#f32b43',
  watchlist: '#ffce60',
  comparison: stingColors.primary['400'],
};

module.exports = reportingColors;
